<ng-container *ngIf="userFocus; else disabledUserFocus">
  <div class="user-focus">
    <div class="user-focus-filter" [ngbTooltip]="userFocusTooltip" [openDelay]="tooltipOpenDelay"
         tooltipClass="rms-tooltip" container="body" placement="top">
      <div class="user-focus-filter-icon primary" [ngClass]="{'disabled': !userFocusFilterMap.get('primary')}"
           (click)="userFocusFilterMap.set('primary', !userFocusFilterMap.get('primary')); onUserFocusChange()">
      </div>
      <div class="user-focus-filter-icon secondary" [ngClass]="{'disabled': !userFocusFilterMap.get('secondary')}"
           (click)="userFocusFilterMap.set('secondary', !userFocusFilterMap.get('secondary')); onUserFocusChange()">
      </div>
      <div class="user-focus-filter-icon follower" [ngClass]="{'disabled': !userFocusFilterMap.get('follower')}"
           (click)="userFocusFilterMap.set('follower', !userFocusFilterMap.get('follower')); onUserFocusChange()">
      </div>
    </div>
    <div class="user-focus-toggle-icon" [ngClass]="{'selected': userFocusToggle}"
         (click)="toggleUserFocus()" (keydown)="toggleUserFocus()"
         [ngbTooltip]="userFocusTooltipText" [openDelay]="tooltipOpenDelay"
         tooltipClass="rms-tooltip" container="body" placement="top">
      <span class="user-focus-icon" aria-hidden="true"></span><span class="visually-hidden">User Focus</span>
    </div>
    <ng-select [(ngModel)]="userFocus" (ngModelChange)="onUserFocusChange()"
               [items]="userFocusList" [multiple]="false" [clearable]="false"
               (open)="userFocusDropdownOpen = true" (close)="userFocusDropdownOpen = false"
               [ngClass]="{'open': userFocusDropdownOpen}">
      <ng-template ng-label-tmp let-item="item">
        {{ item | rmsNameInitials }}
      </ng-template>
    </ng-select>
    <ng-template #userFocusTooltip>
      <div class="user-focus-tooltip">
        <div class="user-focus-legend primary"><i class="fa fa-circle"></i> Primary</div>
        <div class="user-focus-legend secondary"><i class="fa fa-circle"></i> Secondary</div>
        <div class="user-focus-legend follower"><i class="fa fa-circle"></i> Following</div>
      </div>
    </ng-template>
  </div>
</ng-container>
<ng-template #disabledUserFocus>
  <div class="user-focus">
    <div class="user-focus-toggle-icon disabled">
      <span class="user-focus-icon" aria-hidden="true"></span><span class="visually-hidden">User Focus</span>
    </div>
    <div class="select-disabled"><rms-loading-spinner></rms-loading-spinner></div>
  </div>
</ng-template>
